var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAthenaOwl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 37",
    shapeRendering: "crispEdges",
    width: 32,
    height: 37,
    "aria-label": "Athena",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0E2A23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 0,
    width: 9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 1,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 1,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 2,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 2,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 3,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 3,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 3,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 3,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 4,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 4,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 4,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 4,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 5,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 5,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 5,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 5,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 5,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 6,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 6,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 7,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 7,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 7,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 7,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 8,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 8,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 8,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 9,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 9,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 9,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 9,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 10,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 10,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 10,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 11,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 11,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 11,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 11,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 12,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 12,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 12,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 12,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 14,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 14,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 15,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 15,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 15,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 16,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 16,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 17,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 17,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 17,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 19,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 19,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 20,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 20,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 20,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 21,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 21,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 21,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 22,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 22,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 22,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 23,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 23,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 23,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 23,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 23,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 23,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 25,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 25,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 25,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 25,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 26,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 26,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 26,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 27,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 27,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 27,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 27,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 28,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 28,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 28,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 28,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 29,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 29,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 29,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 29,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 29,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 29,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 30,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 30,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 30,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 30,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 30,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 31,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 31,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 31,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 31,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 31,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 31,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 32,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 32,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 32,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 32,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 32,
    width: 10,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 33,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 33,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 33,
    width: 8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 34,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 34,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 34,
    width: 7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 35,
    width: 9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 36,
    width: 5,
    height: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#2E6E5C"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 4,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 7,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 8,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 11,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 13,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 14,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 15,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 15,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 16,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 16,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 16,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 17,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 19,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 21,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 22,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 22,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 23,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 25,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 25,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 25,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 26,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 26,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 26,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 26,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 27,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 27,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 28,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 28,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 28,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 29,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 30,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 30,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 30,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 31,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 31,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 31,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 32,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 34,
    width: 1,
    height: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#4F9B81"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 7,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 8,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 10,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 11,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 14,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 15,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 16,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 22,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 23,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 25,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 27,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 28,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 29,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 30,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 30,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 30,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 31,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 31,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 32,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 33,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 34,
    width: 1,
    height: 1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#7DC4A6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 1,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 2,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 3,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 3,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 4,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 5,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 6,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 15,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 16,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 16,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 17,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 17,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 19,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 19,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 20,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 21,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 21,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 21,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 22,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 22,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 23,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 23,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 23,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 24,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 24,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 25,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 25,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 25,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 26,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 26,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 26,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 27,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 27,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 27,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 28,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 28,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 28,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 29,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 29,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 29,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 30,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 30,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 30,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 31,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 31,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 32,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 32,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 33,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 33,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 34,
    width: 1,
    height: 1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#B0DFC6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 1,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 2,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 3,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 3,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 4,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 4,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 5,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 6,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 7,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 8,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 9,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 10,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 11,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 12,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 13,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 14,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 15,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 16,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 17,
    width: 7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 18,
    width: 8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 19,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 19,
    width: 7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 20,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 20,
    width: 7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 21,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 21,
    width: 7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 22,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 23,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 23,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 24,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 24,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 25,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 25,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 26,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 26,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 27,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 27,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 28,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 28,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 29,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 30,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 31,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 32,
    width: 2,
    height: 1
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#DEF1E1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 2,
    width: 1,
    height: 1
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#D5CDB6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 4,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 5,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 6,
    width: 7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 7,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 7,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 8,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 8,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 9,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 10,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 11,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 12,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 13,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 14,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 15,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 16,
    width: 1,
    height: 1
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#FBF7E8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 4,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 5,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 6,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 7,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 7,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 8,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 8,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 9,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 9,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 10,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 11,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 11,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 13,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 14,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 15,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 16,
    width: 1,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthenaOwl);
export default __webpack_public_path__ + "static/media/athena_owl.9bb290f26f151c977e2bcdd8fc16ba2f.svg";
export { ForwardRef as ReactComponent };